import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Wysiwyg from "../../Wysiwyg"
import Edges from "../../Edges"

interface IProductFeatures {
  section: Array<any>
  featuresHeading: string
}

const ProductFeatures: React.FC<IProductFeatures> = ({
  section,
  featuresHeading,
}) => {
  return (
    <Edges size="xl">
      <Edges size="md">
        {featuresHeading && (
          <h2 className="relative top-[15px] mx-[19px] mb-[50px] mt-[50px] text-darkBlue xl:mx-0">
            {featuresHeading}
          </h2>
        )}
      </Edges>
      {section?.map((feature, index) => {
        const gatsbyImage =
          feature?.image && getImage(feature.image.gatsbyImage)
        return (
          <div className="relative" key={index}>
            <Edges size="md">
              <div
                key={index}
                className="mx-auto mb-[55px] flex flex-row flex-wrap md:flex-nowrap"
              >
                {gatsbyImage && (
                  <div className="mx-[19px] mb-[20px] flex min-w-[400px] justify-center md:my-auto xl:mx-0">
                    <GatsbyImage
                      image={gatsbyImage}
                      alt={feature?.image?.altText || ""}
                    />
                  </div>
                )}
                <div className="mx-[19px] flex max-w-[500px] flex-col justify-center">
                  <h4 className="mb-[10px] text-darkBlue">{feature.title}</h4>
                  {feature?.content && <Wysiwyg content={feature?.content} />}
                </div>
              </div>
            </Edges>
            <div className="mx-auto mb-[57px] max-w-[1250px] border-b-[2px] border-lightGrey"></div>
          </div>
        )
      })}
    </Edges>
  )
}

export default ProductFeatures
